import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useState } from 'react';
import { H4 } from 'UIComponents/elements/headings';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const TIME_TO_DISPLAY_TOOLTIP = 3500;
export const EmptyStateTour = ({
  children,
  hasClosedTourFromModal
}) => {
  const [showTour, setShowTour] = useState(false);
  useEffect(() => {
    // Don't show tour when welcome modal was just closed
    if (hasClosedTourFromModal) {
      setShowTour(false);
      return () => {};
    }
    // The tooltip should be shown with a delay after page load
    const timeoutId = setTimeout(() => {
      setShowTour(true);
    }, TIME_TO_DISPLAY_TOOLTIP);
    return function cleanup() {
      clearTimeout(timeoutId);
    };
  }, [hasClosedTourFromModal]);
  useEffect(() => {
    trackDashboardInteraction('view-start-tooltip');
  }, []);
  const onCloseButtonClick = () => {
    setShowTour(false);
    trackDashboardInteraction('close-start-tooltip');
  };
  return /*#__PURE__*/_jsx(UIPopover, {
    autoPlacement: false,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dashboard.zeroState.tour.createFreeForm.header"
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "dashboard.zeroState.tour.createFreeForm.body"
      })
    },
    closeOnOutsideClick: false,
    "data-test-id": "forms-empty-state-tour",
    open: showTour,
    onOpenChange: onCloseButtonClick,
    placement: "bottom left",
    showCloseButton: true,
    use: "shepherd",
    children: children
  });
};